import { Modal, ModalProps, withModalConditionalRender } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { VatExemptionMentionModalFormContextProvider } from './context/vatExemptionMentionModalFormContext'
import { VatExemptionMentionModalBody } from './elements/VatExemptionMentionModalBody'
import { VatExemptionMentionModalFooter } from './elements/VatExemptionMentionModalFooter'

interface VatExemptionMentionModalProps extends ModalProps {
  defaultValue: string
  isSubmitting?: boolean
  onSubmit: (value: string) => void
}

const VatExemptionMentionModalComponent = ({
  defaultValue,
  isSubmitting = false,
  onSubmit,
  ...modalProps
}: VatExemptionMentionModalProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Modal {...modalProps} size="s">
      <VatExemptionMentionModalFormContextProvider defaultValue={defaultValue} onSubmit={onSubmit}>
        <Modal.Header title={t('settings.organization.external_invoice.general.vat_exemption_mention.modal.title')} />
        <VatExemptionMentionModalBody />
        <VatExemptionMentionModalFooter id={modalProps.id} isSubmitting={isSubmitting} />
      </VatExemptionMentionModalFormContextProvider>
    </Modal>
  )
}

export const VatExemptionMentionModal = withModalConditionalRender(VatExemptionMentionModalComponent)
